export enum ConfirmationModal {
  Title = 'Ваша заявка принята!',
  Text = 'В ближайшее время с вами свяжется оператор для дальнейшего оформления записи. Спасибо за выбор Лабораторной службы Хеликс!',
}
